const _ = require('underscore');

const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

function splitter(...args) {
  const obj = [];
  let options;
  let priceLabel;

  if (args.length) {
    options = args[args.length - 1];

    for (let i = 0; i < args.length - 1; i += 1) {
      priceLabel = _.object(['label'], args[i].split('[PRICE]'));
      obj.push({
        label: priceLabel.label.replace(rtrim, ''),
        showPrice: args[i].indexOf('[PRICE]') >= 0,
      });
    }

    return options.fn(this, {
      data: options.data,
      blockParams: obj,
    });
  }

  return '';
}

module.exports = splitter;
